import { c as _c } from "react/compiler-runtime";
export const DataErrorFallback = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="mx-16 flex flex-col items-center justify-center rounded-medium bg-Gray-white p-20"><p className="text-Gray-600 typo-body3">데이터를 불러오는데 실패했습니다.</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};